import React, {useState, useEffect} from 'react';

const FieldPlaceholder = ({value, onChange}) => {

  const [_value, setValue] = useState(value);

  useEffect(() => onChange(_value), [_value]);

  return <div className="mb-3">
    <label htmlFor="placeholder" className="form-label">Placeholder</label>
    <input id="placeholder"
           type="text"
           className="form-control"
           value={_value || ''}
           onChange={e => setValue(e.target.value)} />
    <div className="form-text">Short hint, will appear in the field before it is filled out.</div>
  </div>
};

export default FieldPlaceholder;
